import { inject, Injectable, signal } from '@angular/core';
import { LoginDataResponse } from '../../../../generated-sources/openapi/model/loginDataResponse';
import { SignalrService } from './signalr.service';

const TOKEN = 'frakcio-monitoring-token';
const USER = 'frakcio-monitoring-user';

@Injectable({ providedIn: 'root' })
export class LoginService {
  private readonly signalrService = inject(SignalrService);
  private readonly _isAuthenticated = signal<boolean>(!!localStorage.getItem(TOKEN));

  readonly isAuthenticated = this._isAuthenticated.asReadonly();

  login(token: string, user: LoginDataResponse): void {
    localStorage.setItem(TOKEN, token);
    localStorage.setItem(USER, JSON.stringify(user));
    console.log(user);
    this._isAuthenticated.set(true);
    this.signalrService.startConnection(this.getFirstCondominium()?.IPBackendMiddlewareMonitoring ?? '');
  }

  private getFirstCondominium() {
    return this.getUser()?.condominiums?.[0];
  }

  logout(): void {
    localStorage.removeItem(TOKEN);
    localStorage.removeItem(USER);
    this._isAuthenticated.set(false);
    this.signalrService.stopConnection();
  }

  getToken(): string | null {
    return localStorage.getItem(TOKEN);
  }

  getUser(): LoginDataResponse | null {
    const user = localStorage.getItem(USER);
    return user ? JSON.parse(user) : null;
  }

  getMiddlewareInfo(): { ip: string; user: string; pass: string } {
    // NOTA IMPORTANTE: Se obtiene la conexión del primer condominio, se asume que todos tienen la misma
    const condominium = this.getFirstCondominium();
    return {
      ip: condominium?.IPBackendMiddlewareMonitoring ?? '',
      user: condominium?.userBackendMiddlewareMonitoring ?? '',
      pass: condominium?.passBackendMiddlewareMonitoring ?? '',
    };
  }
}
